import { Box } from "@mui/material";
import Lookup from "./LookupModel";
import { useParams } from "react-router";

function LookupForm() {
    const { lookupTypeId } = useParams();
    return (
        <Box>
            <Lookup.Form baseSaveData={{
                LookupTypeId: parseInt(lookupTypeId)
            }} />
        </Box>
    );
}

export default LookupForm;